import { useTranslations } from "next-intl";

/**
 * "on behalf" — the address goes out through Veltric's own signing domain
 * (`info=firma.de@send.mail-veltric.app`, Reply-To = the address) because
 * nothing signs it with the tenant's own domain. See `isOnBehalf`.
 *
 * A read-only `<span>` (pattern: AcceptanceStateChip) so it never swallows the
 * row click of the table it sits in. The explanation rides in `title` for the
 * mouse and in an `sr-only` tail for assistive tech — a tooltip alone on a
 * non-focusable element is invisible to a screen reader (RecipientLanguageChip).
 */
export const OnBehalfChip: React.FC<{ className?: string }> = ({ className }) => {
  const t = useTranslations("sender");
  const explanation = t("onBehalfTooltip");
  return (
    <span
      data-testid="sender-on-behalf-chip"
      title={explanation}
      className={`inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 body-4-regular w-max user-icon-font-1 user-icon-bg-1 outline-user-icon-1 ${className ?? ""}`}
    >
      {t("onBehalf")}
      <span className="sr-only"> — {explanation}</span>
    </span>
  );
};
